import * as React from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { useAppContext } from "../lib/contextLib";

export default function ResponsiveAppBar() {
  const navigate = useNavigate();
  const { isAuthenticated, userHasAuthenticated } = useAppContext();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const pages = isAuthenticated ? ["Home", "Sources", "Sheets"] : ["Home"];

  function handleOpenNavMenu(event) {
    setAnchorElNav(event.currentTarget);
  }
  function handleOpenUserMenu(event) {
    setAnchorElUser(event.currentTarget);
  }
  function handleCloseNavMenu() {
    setAnchorElNav(null);
  }
  function handleCloseUserMenu () {
    setAnchorElUser(null);
  }

  function handlePage(page) {
    if (page === "Home") {
      navigate("/");
    } else if (page === "Sources") {
      navigate("/sources");
    } else if (page === "Sheets") {
      navigate("/sheets");
    } else if (page === "WPT") {
      navigate("/wpt");
    }
    handleCloseNavMenu();
    handleCloseUserMenu();
  }

  function renderMenuItems(options) {
    return options.map(({ name, handler }) => (
      <MenuItem key={name} onClick={handler}>
        <Typography textAlign="center">{name}</Typography>
      </MenuItem>
    ));
  }
  const unauthedUserMenuItems = renderMenuItems([
    {
      name: 'Login',
      handler: () => {
        navigate("/login");
        handleCloseNavMenu();
        handleCloseUserMenu();
      }
    },
    {
      name: 'Signup',
      handler: () => {
        navigate("/signup");
        handleCloseNavMenu();
        handleCloseUserMenu();
      }
    }
  ]);
  const authedUserMenuItems = renderMenuItems([
    {
      name: 'Settings',
      handler: () => {
        navigate("/settings");
        handleCloseNavMenu();
        handleCloseUserMenu();
      }
    },
    {
      name: 'Logout',
      handler: async () => {
        await Auth.signOut();  
        userHasAuthenticated(false);
        navigate("/login");
        handleCloseNavMenu();
        handleCloseUserMenu();
      }
    }
  ]);

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={() => handlePage(page)}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}  
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
          >
            <Link to="/">LOGO</Link>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={()=> handlePage(page)}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar>
                  <AccountCircleRoundedIcon />
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {isAuthenticated ? authedUserMenuItems : unauthedUserMenuItems}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
